import Bouncer from 'formbouncerjs';
import Inputmask from 'inputmask';

const validateSettings = {
    disableSubmit: true,
    messages: {
        missingValue: {
            'checkbox': 'Обязательное поле',
            'radio': 'Выберите вариант',
            'select': 'Выберите вариант',
            'select-multiple': 'Выберите вариант',
            'default': 'Обязательное поле',
        },
        patternMismatch: {
            email: 'Некорректный email',
            url: 'Некорректный url',
            number: 'Некорректное число',
            color: 'Некорректный цвет',
            date: 'Некорректная дата',
            time: 'Некорректное время',
            month: 'Некорректный месяц',
            default: 'Некорректный формат',
        },
        outOfRange: {
            over: 'Пожалуйста, выберите значение, которое не превышает {max}',
            under: 'Пожалуйста, выберите значение не менее {min}',
        },
        wrongLength: {
            over: 'Максимум {maxLength} символов. Сейчас: {length}',
            under: 'Минимум {minLength} символов. Сейчас: {length}',
        },
        inputFileAccept: 'Неверный формат файла',
        inputFileSize: 'Неверный размер файла',
        inputPasswordMatch: 'Введенные пароли не совпадают',
        inputPhone: 'Некорректный номер телефона',
        inputContract: 'Некорректный номер договора',
        inputTime: 'Некорректное время',
        inputDate: 'Некорректная дата',
        inputSnils: 'Некорректный СНИЛС',
        inputPassport: 'Некорректные серия, номер',
        inputPassportCode: 'Некорректный формат',
        inputFilesRequired: 'Обязательное поле: файл или ссылка на материал',
    },
    customValidations: {
        inputFileAccept(field) {
            if (field.getAttribute('accept')) {
                const { value } = field;
                let accept = field.getAttribute('accept').toLowerCase();
                accept = accept
                    .replace(/\./g, '')
                    .replace(/\s+/g, '')
                    .split(',');
                if (value.length > 0) {
                    const ex = value
                        .substring(value.lastIndexOf('.') + 1)
                        .toLowerCase();
                    if (accept.includes(ex)) {
                        return false;
                    }
                    return true;
                }
            }
        },
        inputFileSize(field) {
            if (field.getAttribute('data-max-size')) {
                const { files } = field;
                const { value } = field;
                const maxsize = field.getAttribute('data-max-size') * 1;
                let size = 0;
                Object.values(files).forEach((file) => {
                    size += file.size;
                });
                if (value.length > 0) {
                    if (size <= maxsize) {
                        return false;
                    }
                    return true;
                }
            }
        },
        inputPasswordMatch(field) {
            if (field.getAttribute('data-password-match')) {
                const inputId = field.getAttribute('data-password-match');
                const input = document.getElementById(inputId);
                if (typeof input !== 'undefined' && input !== null) {
                    if (input.value === field.value) {
                        return false;
                    }
                }
                return true;
            }
        },
        inputPhone(field) {
            if (
                field.getAttribute('data-format') === 'phone' &&
                field.value.length > 0
            ) {
                return !Inputmask.isValid(field.value, {
                    mask: '+7 (999) 999-99-99',
                });
            }
        },
        inputContract(field) {
            if (
                field.getAttribute('data-format') === 'contract' &&
                field.value.length > 0
            ) {
                return !Inputmask.isValid(field.value, {
                    mask: 'БA/99-999',
                });
            }
        },
        inputPassport(field) {
            if (
                field.getAttribute('data-format') === 'passport' &&
                field.value.length > 0
            ) {
                return !Inputmask.isValid(field.value, {
                    mask: '9999 999999',
                });
            }
        },
        inputPassportCode(field) {
            if (
                field.getAttribute('data-format') === 'passport-code' &&
                field.value.length > 0
            ) {
                return !Inputmask.isValid(field.value, {
                    mask: '999-999',
                });
            }
        },
        inputTime(field) {
            if (field.classList.contains('js-time') && field.value.length > 0) {
                return !Inputmask.isValid(field.value, {
                    alias: 'datetime',
                    inputFormat: 'HH:MM',
                });
            }
        },
        inputDate(field) {
            if (
                (field.classList.contains('js-date') ||
                    field.classList.contains('form__input--date')) &&
                field.value.length > 0
            ) {
                return !Inputmask.isValid(field.value, {
                    alias: 'datetime',
                    inputFormat: 'dd.mm.yyyy',
                });
            }
        },
        inputFilesRequired(field) {
            if (field.classList.contains('js-input-required')) {
                let flag = true;
                const form = field.closest('.js-form');
                const inputs = form.querySelectorAll('input.js-input-required');
                inputs.forEach((input) => {
                    if (input.value.length > 0) {
                        inputs.forEach((item) => {
                            item.classList.remove('error');
                            const next = item.nextElementSibling;
                            if (next.classList.contains('error-message')) {
                                next.style.display = 'none';
                            }
                        });
                        flag = false;
                    }
                });
                return flag;
            }
        },
        inputSnils(field) {
            if (
                field.getAttribute('data-format') === 'snils' &&
                field.value.length > 0
            ) {
                const gps = String(field.value).replace(/[^0-9]+/g, '');
                if (gps.length === 11) {
                    let checksum = 0;
                    for (let i = 0; i < 9; i++) {
                        checksum += parseInt(gps.charAt(i)) * (9 - i);
                    }
                    if (checksum > 101) {
                        checksum %= 101;
                    }
                    if (checksum === 100 || checksum === 101) {
                        checksum = 0;
                    }
                    return checksum !== parseInt(gps.substr(9));
                }
                return true;
            }
        },
    },
};

export const formValidate = (form: any, index: any) => {
    if (form !== undefined && form !== null) {
        form.setAttribute('novalidate', '');
        form.classList.add(`js-form-validate-${index}`);

        const formBouncer = new Bouncer(
            `.js-form-validate-${index}`,
            validateSettings
        );

        form.addEventListener('reset', () => {
            const inputs = form.querySelectorAll('input,select,textarea');
            inputs.forEach((input) => {
                input.classList.remove('error');
            });
        });
    }
};

export const formAreValid = (fieldset: any) => {
    if (fieldset !== undefined && fieldset !== null) {
        const formBouncer = new Bouncer();
        return formBouncer.validateAll(fieldset, validateSettings);
    }
};

document.addEventListener('DOMContentLoaded', () => {
    const jsform = document.querySelectorAll('.js-form');
    jsform.forEach((form, index) => {
        formValidate(form, index);
    });
});
